import { handleAjaxError } from "./handleAjaxError";

/**
 * Remove a pinned message card from the DOM smoothly and remove the parent group if empty.
 * @param {jQuery} submitBtn
 */
export function removePinnedMessageCard(submitBtn) {
    const $message = submitBtn.closest('.g-chatform-pinned-single-message').length
        ? submitBtn.closest('.g-chatform-pinned-single-message')
        : submitBtn.closest('.g-chatform-message');
    const $singleGroup = submitBtn.closest('.g-chatform-pinned-single');
    const $content = submitBtn.closest('.g-chatform-content');
    const $counter = $singleGroup.find('.e-pins-counter');

    $message.fadeOut(300, function () {
        $message.remove();
        const remainingCount = $content.find('.g-chatform-pinned-single-message, .g-chatform-message').length;
        if (remainingCount === 0) {
            $singleGroup.fadeOut(300, function () {
                $singleGroup.remove();
            });
        } else if ($counter.length) {
            $counter.text(remainingCount);
        }
    });
}

/**
 * @param message
 * @param chatForm
 */
export function pinMessage() {
    $(document)
        .off('click.growtypeChatPinMessage', '.g-chatform-message-pin')
        .on('click.growtypeChatPinMessage', '.g-chatform-message-pin', function (event) {
            event.preventDefault();

            let submitBtn = $(this);
            let messageId = submitBtn.closest('.g-chatform-message').attr('data-id');

            if (submitBtn.hasClass('is-loading') || submitBtn.hasClass('is-disabled')) {
                return;
            }

            submitBtn.addClass('is-loading');

        /**
         * Analytics
         */
            if (typeof growtypeAnalyticsCapture === 'function') {
                growtypeAnalyticsCapture('growtype_analytics_growtype_chat_action_clicked', {
                    title: 'pin_message'
                });
            }

            jQuery.ajax({
                url: growtype_chat_ajax.url,
                type: 'post',
                data: {
                    message_id: messageId,
                    action: growtype_chat_ajax.pin_message_action,
                    nonce: growtype_chat_ajax.nonce,
                }, success: function (response) {

                    if (response?.success === false) {
                        handleAjaxError({ responseJSON: response }, submitBtn);
                        return;
                    }

                    if (response.data.message_pined) {
                        submitBtn.addClass('is-pinned');
                        submitBtn.find('span').text('Pinned');
                    } else {
                        submitBtn.removeClass('is-pinned');
                        submitBtn.find('span').text('Pin');
                    }

                    if (submitBtn.closest('.g-chatform-pinned').length > 0) {
                        removePinnedMessageCard(submitBtn);
                    }

                    submitBtn.removeClass('is-loading');
                }, error: function (response) {
                    handleAjaxError(response, submitBtn);
                }
            });
        });
}
